import { Note, NoteBook, SearchNoteResponse } from "../model/models";
import {httpService} from '../App'
import { createLogger } from '../utils/logger';

const logger = createLogger('NotebookService');

export class NotebookService {
  async readNotebooksByOwner(ownerId: number): Promise<NoteBook[]>{
    try {
      const response = await httpService.getClient().get(`/api/notebook/owner/${ownerId}`);
      logger.debug(`readNotebooksByOwner() ownerId:${ownerId} - HTTP-${response?.status}`);
      return response ? response.data ?? [] : [];
    } catch (error) {
      logger.error(error);
      return []
    }
  }

  async readNotesByNotebook(notebookId: number): Promise<Note[]>{
    logger.debug(`readNotesByNotebook() notebookId:${notebookId}`);
    try {
      const response = await httpService.getClient().get(`/api/note/notebook/${notebookId}`);
      //console.log(response);
      return response ? response.data ?? [] : [];
     } catch (error) {
       logger.error(error);
       return []
     }
   }

   async readNotebookById(notebookId: number): Promise<NoteBook | undefined>{
     try {
       const response = await httpService.getClient().get(`/api/notebook/${notebookId}`);
       logger.debug(`readNotebookById() by ${notebookId}`);
       return response ? response.data ?? {} : {};
     } catch (error) {
       logger.error(error);
       return undefined
     }
   }

   async readNoteById(noteId: number): Promise<Note | undefined>{
     try {
       const response = await httpService.getClient().get(`/api/note/${noteId}`,
       {withCredentials:true});
       logger.debug(`readNoteById() by ${noteId}`);
       return response ? response.data ?? {} : {};
     } catch (error) {
       logger.error(error);
       return undefined
     }
   }

   async readByName(name:string):Promise<NoteBook|undefined>{
     logger.debug(`readByName() ${name}`);
     
     try {
       const response = await httpService.getClient().post(`/api/notebook/validate`,{
         name,
       });
       
       return response ? response.data ? response.data.length > 0 ? response.data[0] : undefined : undefined : undefined;
     } catch (error) {
       logger.error(error);
     }
   }


   async createNotebook(notebook:Partial<NoteBook>):Promise<void>{
     try {
       const response = await httpService.getClient().post(`/api/notebook`,{
         name:notebook.name,
         owner_id:notebook.owner_id 
       });
       logger.debug(`createNotebook() by ${notebook.name} response:${response?.status}`);
     } catch (error) {
       logger.error(error);
     }
   }

   async createNote(note:Partial<Note>):Promise<number>{
     try {
       const response = await httpService.getClient().post(`/api/note`,{
         name:note.name,
         text:note.text,
         note_book_id:note.note_book_id
       });
       logger.debug(`createNote() name:${note.name} on notebook:${note.note_book_id}`);
       return response?.data ?? -1;
     } catch (error) {
       logger.error(error);
       return -1;
     }
   }

   async updateNote(note:Partial<Note>):Promise<void>{
     try {
       const response = await httpService.getClient().patch(`/api/note/${note.id}`,{
         name:note.name,
         text:note.text,
         id:note.id
       });
       logger.debug(`updateNote() by ${note.id}`);
       return response;
     } catch (error) {
       logger.error(error);
     }
   }

   public async heartbeat():Promise<void>{
     try {
       const response = await httpService.getClient().get(`/api/heartbeat/pum`);
       logger.debug(`heartbeat()`);
       return response;
     } catch (error) {
       logger.error(error);
     }
   }

   public async readLatestNotesByOwner(): Promise<SearchNoteResponse[]> {
     try {
       const response = await httpService.getClient().get(`/api/note/latest/get`);
       return response ? response.data ?? [] : [];
     } catch (error) {
       logger.error(error);
       return [];
     }
   }

   public async searchNotesByQuery(query:string): Promise<SearchNoteResponse[]> {
     try {
       const response = await httpService.getClient().get(`/api/note/search/q`,{params:{name:query}});
       logger.debug(`searchNotesByQuery() query:${query}`);
       return response ? response.data ?? [] : [];
     } catch (error) {
       logger.error(error);
       return [];
     }
   }

}
